"use strict";

(function(z, Backbone){

    var SuppliersModel = Backbone.Model.extend({
        urlRoot: "/api/suppliers",
        validation: {
            name: [{
                required: true,
                msg: Translator.trans("js.error_message_suppliersform_name_required")
            },{
                minLength: 1,
                msg: Translator.trans("js.error_message_suppliersform_name_minlength")
            },{
                maxLength: 100,
                msg: Translator.trans("js.error_message_suppliersform_name_maxlength")
            }],
            sapSupplierId: [{
                required: true,
                msg: Translator.trans("js.error_message_suppliersform_id_required")
            },{
                minLength: 1,
                msg: Translator.trans("js.error_message_suppliersform_id_minlength")
            },{
                maxLength: 30,
                msg: Translator.trans("js.error_message_suppliersform_id_maxlength")
            }],
            supplierSapType: [{
                required: true,
                msg: Translator.trans("js.error_message_suppliersform_type_required")
            }],
            status: [{
                required: true,
                msg: Translator.trans("js.error_message_suppliersform_status_required")
            }],
        },

        /**
         * Parses the response and returns the appropriate data
         * @param {Object} response The reponse
         * @return {Object} The data
         */
        parse: function(response){

            if( !_.isUndefined(response.data) ){

                return response.data;
            }

            return response;
        }
    });

    z.SuppliersModel = SuppliersModel;

})(window.z = window.z || {}, Backbone);
